import { Outlet } from "@tanstack/react-router";
import { useAuthGuard } from "@/hooks/useAuthGuard";

export default function ProtectedLayout() {
  const { isAuthenticated, isRehydrated } = useAuthGuard();

  if (!isRehydrated || !isAuthenticated) return null;

  return <Outlet />;
}
